<template lang="html">
    <div id="page__search" class="toolbar-search">
        <z-select v-model="filter.type" light v-on:input="onFilter">
            <option value="">Тип (все)</option>
            <option :value="1">Юр. лица</option>
            <option :value="3">ИП</option>
            <option :value="2">Физ. лица</option>
        </z-select>
        <z-select v-model="filter.agent" light v-on:input="onFilter">
            <option value="">Принципал (все)</option>
            <option :value="0">Клиенты</option>
            <option :value="1">Перевозчики</option>
        </z-select>
        <z-select v-model="filter.nds" light v-on:input="onFilter">
            <option value="">НДС (все)</option>
            <option :value="1">c НДС</option>
            <option :value="0">без НДС</option>
        </z-select>
        <z-select v-model="filter.liquidated" light v-on:input="onFilter">
            <option value="">Ликвидирован (все)</option>
            <option :value="1">Ликвидирован</option>
            <option :value="0">Активен</option>
        </z-select>

        <input
            class="toolbar-search__input" id="toolbar-search__input" name="toolbar-search__input" type="text" placeholder="Поиск..." autocomplete="toolbar-search__input"
            v-model="filter.search" v-on:keyup.enter="onFilter" v-on:keyup="onSearchFilter" v-bind:readonly="!focus" v-on:focus="onFocus" v-on:blur="onBlur" ref="search-input"
        ></input>

        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZSelect     from '@/components/ZSelect.vue';
    export default {
        components: { ZIconButton, ZSelect },
        data() {
            return {
                filter: {
                    search: null,
                    liquidated: '',
                    type: '',
                    agent: '',
                    nds: ''
                },
                default: {
                    search: null,
                    liquidated: '',
                    type: '',
                    agent: '',
                    nds: ''
                },
                focus: false,
            }
        },
        created() {
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        methods: {
            onFocus() {
                this.focus = true;
            },
            onBlur() {
                this.focus = false;
            },
            toCustomer(customer) {
                this.$router.push({ name: 'CustomerEdit', params: { customerid: customer.id }, query: this.$route.query })
            },
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            onSearchFilter() {
                if (!this.filter.search || (this.filter.search && this.filter.search.lenght < 4)) return;
                this.onFilter();
            },
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });

                setTimeout(() => this.$root.$emit('refresh-table', 'customers'), 100);
            },
            onReset() {
                this.filter = Object.assign({}, this.filter.default);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({ 
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                
                setTimeout(() => this.$root.$emit('refresh-table', 'customers'), 100);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// SearchToolbar.vue?5e2ae028